import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-619b7333"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card shadow-md w-full"
}
const _hoisted_2 = { class: "card-head" }
const _hoisted_3 = { class: "text-primary font-bold font-xs text-center mt-2" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "border-separate spacing font-xs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-auto mr-5" }),
    /*#__PURE__*/_createElementVNode("th", { class: "w-auto" })
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Transacción No:", -1))
const _hoisted_8 = { class: "text-gris80 font-bold" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Medio de pago:", -1))
const _hoisted_10 = { class: "text-gris80" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Referencia:", -1))
const _hoisted_12 = { class: "text-gris80" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Descripción:", -1))
const _hoisted_14 = { class: "text-gris80" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Email:", -1))
const _hoisted_16 = { class: "text-gris80" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Valor:", -1))
const _hoisted_18 = { class: "text-gris80" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Fecha Transacción:", -1))
const _hoisted_20 = { class: "text-gris80" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Estado:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-primary" }, "Dirección IP:", -1))
const _hoisted_23 = { class: "text-gris80" }
const _hoisted_24 = { class: "card-footer" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  onclick: "window.print()",
  class: "px-4 py-2 text-sm text-white font-bold rounded-lg bg-primary w-48 md:w-44 md:mt-0 md:text-sm h-10 my-3"
}, " Imprimir ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary text-center" }, [
  /*#__PURE__*/_createTextVNode(" Si tiene dudas con la información relacionada, escribanos a "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:contactenos@sc.jccolombia.co",
    class: "font-bold"
  }, "contactenos@sc.jccolombia.co")
], -1))
const _hoisted_27 = {
  key: 0,
  class: "msg-pending"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-center mt-3 overflow-clip" }, " Su pago se encuentra en estado pendiente, por favor consulte nuevamente el estado de su pago en aproximadamente 30 minutos a través del siguiente enlace ", -1))
const _hoisted_29 = { class: "flex gap-2 mt-2" }
const _hoisted_30 = { class: "bg-primary text-white font-bold p-2 rounded" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checked = _resolveComponent("checked")!
  const _component_error = _resolveComponent("error")!
  const _component_pending = _resolveComponent("pending")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return (!_ctx.loading && !_ctx.errorOccurred)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.transactionStatus.status === 'APPROVED')
            ? (_openBlock(), _createBlock(_component_checked, {
                key: 0,
                color: 'text-success',
                width: 48,
                height: 48
              }))
            : _createCommentVNode("", true),
          (_ctx.transactionStatus.status === 'REJECTED')
            ? (_openBlock(), _createBlock(_component_error, {
                key: 1,
                color: 'text-primary',
                width: 48,
                height: 48
              }))
            : _createCommentVNode("", true),
          (_ctx.transactionStatus.status === 'PENDING')
            ? (_openBlock(), _createBlock(_component_pending, {
                key: 2,
                color: 'text-secondary',
                width: 48,
                height: 48
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_3, " Transacción " + _toDisplayString(_ctx.transactionStatus.statusMsg), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_7,
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.transactionStatus.transactionId), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_9,
                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.transactionStatus.paymentMethod), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.transactionStatus.reference), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.transactionStatus.description), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_15,
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.transactionStatus.email), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$filters.currency(_ctx.transactionStatus.value)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_19,
                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.transactionStatus.date), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("td", {
                  class: _normalizeClass(["font-bold", _ctx.setClassStatus(_ctx.transactionStatus.status)])
                }, _toDisplayString(_ctx.transactionStatus.statusMsg), 3)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_22,
                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.transactionStatus.ip), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectHome && _ctx.redirectHome(...args))),
            class: "px-4 py-2 text-sm text-gris80 font-bold rounded-lg bg-lightBackground w-48 md:w-44 md:mt-0 md:text-sm h-10 my-3"
          }, " Ir a Sucursal Virtual "),
          _hoisted_26,
          (_ctx.transactionStatus.status === 'PENDING')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.urlPaymentValidator) = $event)),
                    class: "border p-2 rounded w-full",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, _ctx.urlPaymentValidator]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_30, [
                    _createTextVNode(" Copiar ")
                  ])), [
                    [_directive_clipboard, _ctx.urlPaymentValidator, "copy"],
                    [_directive_clipboard, _ctx.onSuccess, "success"],
                    [_directive_clipboard, _ctx.onError, "error"]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}